module.exports = __webpack_public_path__ + "static/img/19@2x.53372f07.png";